export async function getServer(connectionRepository, url) {
    return await connectionRepository.get(url)
}